import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import { TostadorFetching } from "../../../class/fetchTostador";
import "../Tostador.css";
import { useDate } from "../../../hooks/useDate";

export default function PerfilEnfriador2() {
  // Objeto inicial de la peticion
  const initialFetchEnfriador1 = new TostadorFetching()
    .setIdSeccion(4)
    .setSecuencia(29);

  const initialFetchEnfriador2 = new TostadorFetching()
    .setIdSeccion(4)
    .setSecuencia(28);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  //const [potencia, setPotencia] = useState(defaultObject);
  const [temperaturaSalida1, setTemperaturaSalida1] = useState(defaultObject);
  const [temperaturaSalida2, setTemperaturaSalida2] = useState(defaultObject);
  //const [factorUa, setFactorUa] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetchEnfriador1);
      const enfriador2 = await getValoresPeriodo(initialFetchEnfriador2);

      if (data) {
        //populatePotencia(data);
        populateTemperaturaSalida1(data);

        //populateFactorUa(data);
        // usamos el hook de fecha para guardar los datos del periodo
        setDateHook(data, "Temperatura Salida Enfriador 1");
      }

      if (enfriador2.data) {
        populateTemperaturaSalida2(enfriador2.data);
      }
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
  function populatePotencia(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Potencia Enfriador 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setPotencia({
      fecha: arrFechas,
      value: arrValues,
    });
  }*/

  function populateTemperaturaSalida2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Enfriador 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTemperaturaSalida2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTemperaturaSalida1(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Temperatura Salida Enfriador 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setTemperaturaSalida1({
      fecha: arrFechas,
      value: arrValues,
    });
  }
  /*
  function populateFactorUa(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Factor UA Enfriador 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFactorUa({
      fecha: arrFechas,
      value: arrValues,
    });
  }*/

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Temperatura Enfriador Calcina"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Temperatura Salida Enfriador 1 --------------------------------------- */}
            <Chart.Line
              name="Temperatura Salida Enfriador 1"
              data={temperaturaSalida1.value}
              yAxis={0}
            />

            {/** -------------------------------- Temperatura Salida Enfriador 2 --------------------------------------- */}
            <Chart.Line
              name="Temperatura Salida Enfriador 2"
              data={temperaturaSalida2.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={temperaturaSalida1.fecha} />

            <Chart.YAxis
              labelSuffix=" °C"
              title="Temperatura Enfriador 1 y 2, °C"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" °C"
              title="Temperatura Enfriador 1 y 2, °C"
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix=" °C " />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
